import { camelCase, upperFirst } from "lodash";
import styles from "./plugin.rtlignore-scss";
const getContainerData = (node) => {
  const data = `${camelCase(node.type)}Data`;
  return node?.[data]?.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};
export {
  alignmentClassName,
  getAlignmentClassName,
  getSizeClassName,
  getTextWrapClassName,
  sizeClassName,
  textWrapClassName
};
//# sourceMappingURL=getClassNames.js.map
